const DASHBOARD_API_URL: string =
  process.env.VUE_APP_DASHBOARD_API_URL + "/v2/";
const DASHBOARD_V1_URL: string =
  process.env.VUE_APP_MERCHANT2_BASE_URL + "/dashboard/#/";

export const DASHBOARD_V1_URLS: Record<string, string> = {
  HOME: DASHBOARD_V1_URL,
  PROFILE: `${DASHBOARD_V1_URL}profile`, //Company/Country swap on profile
};

export const DASHBOARD_API_URLS: Record<string, string> = {
  GET_USER_DETAILS: `${DASHBOARD_API_URL}get-user-details`,
  CHANGE_COMPANY: `${DASHBOARD_API_URL}change-company`,
  ADD_IN_CONSOLE_MESSAGE: `${DASHBOARD_API_URL}add-in-console-messages`,
  LIST_IN_CONSOLE_MESSAGES: `${DASHBOARD_API_URL}get-all-in-console-messages`,
  DELETE_IN_CONSOLE_MESSAGE: `${DASHBOARD_API_URL}delete-in-console-messages`,
  SHIP_USER_CREDIT_CARD: `${DASHBOARD_API_URL}ship-user-credit-card`,
  GET_USER_DETAILS_FOR_CARD_SHIPMENT: `${DASHBOARD_API_URL}get-user-details-for-card-shipment`,
  GET_CREDIT_CARD_OR_SHIPMENT_INFO: `${DASHBOARD_API_URL}get-credit-card-or-shipment-info`,
  UPDATE_CREDIT_CARD_OR_SHIPMENT_STATUS: `${DASHBOARD_API_URL}update-credit-card-or-shipment-status`,
  MARK_SHIPMENT_AS_DELIVERED: `${DASHBOARD_API_URL}mark-shipment-as-delivered`,
  // Operation Hours
  GET_OPERATION_HOURS: `${DASHBOARD_API_URL}get-operation-hours`,
  UPDATE_DEFAULT_HOURS: `${DASHBOARD_API_URL}update-default-hours`,
  ADD_SPECIAL_DATE: `${DASHBOARD_API_URL}add-special-date`,
  UPDATE_SPECIAL_DATE: `${DASHBOARD_API_URL}update-special-date`,
  DELETE_SPECIAL_DATE: `${DASHBOARD_API_URL}delete-special-date`,
};

export const UTILITIES_API_URLS: Record<string, string> = {
  LOG: `${DASHBOARD_API_URL}add-user-log`,
};
